import siteEquipmentsClient from '@/core/api/site-equipments-service';
import {
  ISiteEquipmentCustomerDetailDTO,
  DocumentListItemDTO,
} from '@/../client-generator/generated-clients/siteEquipments';
import { Vue, Component } from 'vue-property-decorator';
import DocsList from '@/views/components/DocsList/DocsList.vue';

@Component({
  components: {
    DocsList,
  },
})
export default class EmployeeDetail extends Vue {
  isLoading = true;

  siteEquipmentId = 0;
  siteEquipment: ISiteEquipmentCustomerDetailDTO | null = null;

  documents: DocumentListItemDTO[] = [];
  get siteEquipmentTitle() {
    let title = '';
    if (this.siteEquipment?.brandName || this.siteEquipment?.model) {
      title = ` - ${[this.siteEquipment?.brandName, this.siteEquipment?.model].filter(Boolean).join(' ')}`;
    }
    return `${this.siteEquipment?.serialNumber + title}`;
  }

  mounted() {
    this.siteEquipmentId = +this.$route.params.siteEquipmentId;
    this.fetchDetails();
  }

  updatedActiveTab(activeTabIndex) {
    switch (activeTabIndex) {
      case 1: {
        // documents
        this.fetchDocuments();
        break;
      }

      default:
        break;
    }
  }

  async fetchDetails() {
    try {
      this.siteEquipment = await siteEquipmentsClient.detailCustomer(this.siteEquipmentId);
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        case 404:
          messageError = this.$t('siteEquipmentNotFound').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.isLoading = false;
    }
  }

  async fetchDocuments() {
    if (this.documents.length !== 0) return;

    this.isLoading = true;
    try {
      const response = await siteEquipmentsClient.documents(this.siteEquipmentId, undefined);
      this.documents = response.data as DocumentListItemDTO[];
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.isLoading = false;
    }
  }

  backToList() {
    this.$router.push({
      name: 'page-site-equipments',
    });
  }
}
